'use strict';

define(['jquery'], function ($) {

  var $listItem = $('.buy-now-item');
  var totalItems = $listItem.length;
  var setItemId = function setItemId() {
    $listItem.each(function (i) {
      $(this).attr('id', 'placement-' + (i + 1));
    });
  };
  var buildContent = function buildContent(placement) {
    var itemContent = $(placement).html();
    return itemContent;
  };
  var loopCount = 1;

  setItemId();

  setInterval(function () {
    var itemReplaceNumber = randomXToY(5, totalItems);
    var currentItem = '#placement-' + loopCount;
    var newItem = '#placement-' + itemReplaceNumber;
    var oldContent = buildContent(currentItem);
    var newContent = buildContent(newItem);

    $(currentItem).animate({
      opacity: 0
    }, 500, function () {
      $(currentItem).html(newContent).animate({
        opacity: 1
      }, 500);
    });

    $(newItem).html(oldContent);

    if (loopCount === 4) {
      loopCount = 1;
    } else {
      loopCount++;
    }
  }, 3000);

  // Function to get random number between minVal and maxVal
  function randomXToY(minVal, maxVal, floatVal) {
    var randVal = minVal + Math.random() * (maxVal - minVal);
    return typeof floatVal === 'undefined' ? Math.round(randVal) : randVal.toFixed(floatVal);
  }
});
//# sourceMappingURL=buying-right-now.js.map
